import { render } from "./Index_team.vue?vue&type=template&id=7b568262&scoped=true"
import script from "./Index_team.vue?vue&type=script&lang=js"
export * from "./Index_team.vue?vue&type=script&lang=js"

import "./Index_team.vue?vue&type=style&index=0&id=7b568262&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b568262"

export default script